"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Channel = void 0;

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var count = 0;

function makeName() {
  return "MessageChannel".concat(++count);
}

var Channel =
/*#__PURE__*/
function () {
  babelHelpers.createClass(Channel, [{
    key: "init",
    value: function init(channelTarget, origin) {
      Object.assign(this, {
        channelTarget: channelTarget,
        origin: origin,
        callIdPrefix: "".concat(Date.now(), "_"),
        callId: 1,
        pending: []
      });

      if (channelTarget && origin) {
        window[this.name] = this;
        window.addEventListener('message', this._eventHandler, false);
        this.initialized = true;

        this._finishPending();
      }
    }
  }]);

  function Channel(channelTarget, origin, _name) {
    var _this = this;

    babelHelpers.classCallCheck(this, Channel);
    this.events = {};
    this._pendingIncoming = [];
    this.initialized = false;

    this._dispatchEvent = function (name, object) {
      if (_this.events[name]) {
        for (var i = 0; i < _this.events[name].length; i++) {
          var f = _this.events[name][i];

          try {
            f(object || {});
          } catch (e) {
            ;
          }

          return true;
        }
      }
    };

    this._eventHandler = function (event) {
      if (event.origin == _this.origin && event.source == _this.channelTarget) {
        _this.messageHandler(event.data);
      }
    };

    this.methods = {
      DispatchEvent: this._dispatchEvent
    };
    this.name = _name || makeName();
    this.init(channelTarget, origin);
  }

  babelHelpers.createClass(Channel, [{
    key: "destroy",
    value: function destroy() {
      window.removeEventListener('message', this._eventHandler, false);
    }
  }, {
    key: "_finishPending",
    value: function _finishPending() {
      while (this._pendingIncoming.length) {
        this.messageHandler(this._pendingIncoming.shift());
      }
    }
  }, {
    key: "call",
    value: function call(method) {
      var callId = "".concat(this.callIdPrefix).concat(++this.callId);
      var R;
      var obj = new _promisePolyfill.default(function (resolve, reject) {
        R = {
          resolve: resolve,
          reject: reject
        };
      });

      obj.success = function (value) {
        return obj.then(value);
      };

      obj.error = function (value) {
        return obj.catch(value);
      };

      obj.complete = function (fn) {
        return obj.then(function (value) {
          return fn(null, value);
        }).catch(function (value) {
          return fn(value, null);
        });
      };

      this.pending.push({
        id: callId,
        callback: function callback(err, result) {
          if (err) R.reject(err);else R.resolve(result);
        }
      });

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this.call_message(callId, method, args);
      return obj;
    }
  }, {
    key: "call_message",
    value: function call_message(callId, method, args) {
      this.channelTarget.postMessage(JSON.stringify({
        id: callId,
        name: this.name,
        method: method,
        args: args
      }), this.origin);
    }
  }, {
    key: "messageHandler",
    value: function messageHandler(d) {
      if (!this.initialized) {
        this._pendingIncoming.push(d);

        return;
      }

      var data = JSON.parse(d);
      if (data.name != this.name) return;

      if ('method' in data && 'args' in data) {
        var method = data.method,
            args = data.args;

        if (this.methods[method]) {
          try {
            var r = this.methods[method].apply(null, args);
            if (!r) r = null;
            this.doResponse(data.id, null, r);
          } catch (e) {
            this.doResponse(data.id, e, null);
          }
        } else {
          this.doResponse(data.id, new ReferenceError("".concat(method, " is not defined")), null);
        }
      }

      if ('error' in data && 'result' in data) {
        var handlers = this.pending.filter(function (v) {
          return v.id == data.id;
        });

        if (handlers.length) {
          handlers.forEach(function (v) {
            try {
              v.callback.call(null, data.error, data.result);
            } catch (e) {
              ;
            }
          });
        }
      }
    }
  }, {
    key: "doResponse",
    value: function doResponse(callId, error, result) {
      error = error || null;
      result = result || null;
      var e = null;

      if (error) {
        e = {};
        e.type = (error.constructor || {
          name: 'UnknownError'
        }).name;
        e.message = error.message;
      }

      this.channelTarget.postMessage(JSON.stringify({
        id: callId,
        name: this.name,
        error: e,
        result: result
      }), this.origin);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(name, handler) {
      if (!this.events[name]) this.events[name] = [];
      this.events[name].push(handler);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(name, handler) {
      if (this.events[name]) {
        this.events[name] = this.events[name].filter(function (v) {
          return v != handler;
        });
        if (this.events[name].length == 0) delete this.events[name];
      }
    }
  }]);
  return Channel;
}(); // export const MessageChannel = new Channel();
// global.MessageChannel = MessageChannel;


exports.Channel = Channel;